import React from 'react';
import { BrowserRouter, Link, Route, Router, Routes } from 'react-router-dom';

/* ***** Layout ***** */
import Header from 'components/Header';
import Footer from 'components/Footer';
/* ***** Layout Ends ***** */

/* ***** Pages ***** */
import Home from 'components/Pages/Home';
import FAQs from 'components/Pages/FAQs';
import Contact from 'components/Pages/Contact';
import Privacy from 'components/Pages/Privacy';
import Safety from 'components/Pages/Safety';
import Terms from 'components/Pages/Terms';
/* ***** Pages Ends ***** */

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/about" element={<FAQs />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/safety" element={<Safety />}></Route>
        <Route path="/terms" element={<Terms />}></Route>
        <Route path="/privacy" element={<Privacy />}></Route>
      </Routes>

      <Footer />
    </BrowserRouter>
  );
};

export default App;
